import * as actionType from "./action";

export function authyOtpReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.TEXT_AUTHY_OTP_SUCCESS:
      return { ...state, response };
    case actionType.TEXT_AUTHY_OTP_ERROR:
      return { ...state, response };
    case actionType.CALL_AUTHY_OTP_SUCCESS:
      return { ...state, response };
    case actionType.CALL_AUTHY_OTP_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function authyRegisterReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.REGISTER_AUTHY_USER_SUCCESS:
      return { ...state, response };
    case actionType.REGISTER_AUTHY_USER_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function authyVerifyReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.VERIFY_AUTHY_OTP_SUCCESS:
      return { ...state, response };
    case actionType.VERIFY_AUTHY_OTP_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function createPasswordNoAuthReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.CREATE_PASSWORD_NOAUTH_SUCCESS:
      return { ...state, response };
    case actionType.CREATE_PASSWORD_NOAUTH_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function loginReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.LOGIN_USER_SUCCESS:
      return { ...state, response };
    case actionType.LOGIN_USER_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function logoutReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.LOGOUT_USER_SUCCESS:
      return { ...state, response };
    case actionType.LOGOUT_USER_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function resetAuthReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.RESET_OPERATION_EMAIL_NOAUTH_SUCCESS:
      return { ...state, response };
    case actionType.RESET_OPERATION_EMAIL_NOAUTH_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function resetPhoneReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.RESET_PHONE_SUCCESS:
      return { ...state, response };
    case actionType.RESET_PHONE_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}
